import Typography from "@mui/material/Typography";
import { useRouter } from "next/router";
import { useAOS } from "@/hooks/useAOS";

const FONT_SIZES = {
  xxl: { xs: "30px", md: "40px", md: "50px" }, //50px
  xl: { xs: "24px", md: "35px", md: "45px" }, //45px
  l: { xs: "20px", md: "24px" }, //24px
  md: { xs: "18px", md: "20px" }, //20px
  sm: { xs: "14px", md: "18px" }, //18px
  xs: { xs: "14px", md: "16px" }, //16px
  xxs: { xs: "12px", md: "14px" }, //14px
};

export default function CustomText({
  text = "text",
  type = "md",
  customStyle,
  variant = "body1",
  enableHtml = false,
  animation = false,
}) {
  useAOS();
  const fontSize = FONT_SIZES[type] || FONT_SIZES.medium;
  const router = useRouter();
  const { locale } = router;
  const isArabic = locale === "ar";
  const myVariant = variant == "p" ? "body1" : variant;
  return enableHtml ? (
    <Typography
      data-aos={animation ? (isArabic ? "fade-right" : "fade-left") : null}
      data-aos-delay={animation ? "500" : "0"}
      variant={myVariant}
      sx={{
        fontSize,
        display: "block",
        lineHeight: 1,
        ...customStyle,
      }}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  ) : (
    <Typography
      data-aos={animation ? (isArabic ? "fade-right" : "fade-left") : null}
      data-aos-delay={animation ? "500" : "0"}
      variant={myVariant}
      sx={{
        fontSize,
        display: "block",
        whiteSpace: "pre-line",
        fontFamily: "inherit",
        lineHeight: 1.2,
        ...customStyle,
      }}
    >
      {text}
    </Typography>
  );
}
